import React from 'react';
import { Lock, Mail,   ArrowRight } from 'lucide-react';

const Paywall = ({ user, featureName }) => {
  const planName = user?.plan?.name || 'Free';

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        {/* Lock Icon */}
        <div className="mx-auto w-20 h-20 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center mb-6">
          <Lock className="h-10 w-10 text-blue-600" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Feature Not Available
        </h1>

        {/* Description */}
        <p className="text-gray-600 mb-6">
          <span className="font-semibold text-gray-800">{featureName}</span> is not included in your current
          <span className="font-semibold text-blue-600"> {planName}</span> plan.
        </p>

        {/* Current Plan Info */}
        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <p className="text-sm text-gray-500 mb-1">Your Current Plan</p>
          <p className="text-lg font-semibold text-gray-900">{planName}</p>
          {user?.plan?.features?.length > 0 && user?.plan?.features[0] !== '*' && (
            <p className="text-xs text-gray-500 mt-1">
              {user.plan.features.length} feature{user.plan.features.length !== 1 ? 's' : ''} included
            </p>
          )}
        </div>

        {/* Upgrade CTA */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg p-6 text-white mb-6">
          <h3 className="text-lg font-semibold mb-2">Want Access?</h3>
          <p className="text-blue-100 text-sm mb-4">
            Contact your administrator to upgrade your plan and unlock this feature.
          </p>

          <div className="space-y-3">
            <a
              href="mailto:admin@mageguard.com?subject=Plan Upgrade Request&body=Hi, I would like to upgrade my plan to access additional features."
              className="flex items-center justify-center w-full bg-white text-blue-600 px-4 py-2 rounded-md font-medium hover:bg-blue-50 transition-colors"
            >
              <Mail className="h-4 w-4 mr-2" />
              Request Upgrade via Email
            </a>
          </div>
        </div>

        {/* Features Preview */}
        <div className="text-left bg-white border border-gray-200 rounded-lg p-4">
          <h4 className="text-sm font-semibold text-gray-900 mb-3">
            What you'll get with {featureName}:
          </h4>
          <ul className="space-y-2 text-sm text-gray-600">
            <li className="flex items-start">
              <ArrowRight className="h-4 w-4 text-blue-500 mr-2 mt-0.5 flex-shrink-0" />
              Full access to all {featureName.toLowerCase()} data and insights
            </li>
            <li className="flex items-start">
              <ArrowRight className="h-4 w-4 text-blue-500 mr-2 mt-0.5 flex-shrink-0" />
              Real-time updates and notifications
            </li>
            <li className="flex items-start">
              <ArrowRight className="h-4 w-4 text-blue-500 mr-2 mt-0.5 flex-shrink-0" />
              Export and reporting capabilities
            </li>
          </ul>
        </div>

        {/* Footer note */}
        <p className="text-xs text-gray-400 mt-6">
          Plan upgrades are managed by your organization's administrator.
        </p>
      </div>
    </div>
  );
};

export default Paywall;
